(function () {
  var OPEN_LOCK_MS = 2500;
  var TADA_WAIT_MS = 12000;
  var EMAIL_WAIT_MS = 12000;
  var POLL_MS = 80;
  var LOCK_WATCH_MS = 30000;
  var AUTO_OPEN_WAIT_MS = 12000;
  var AUTO_OPEN_POLL_MS = 250;
  var lastEmailsByFormId = {};
  var lastEmail = '';
  var opening = false;
  var openedAt = 0;
  var emailLockObserver = null;
  var emailLockTimer = null;
  var tadaSuppressObserver = null;
  var tadaGuardTimer = null;
  var tadaScanTimer = null;
  var successObserver = null;
  var successScanTimer = null;
  var klaviyoSubmitTriggered = false;
  var tadaAllowed = false;

  function boot() {
    if (window.__bts26BlindBoxLotteryBound) return;
    window.__bts26BlindBoxLotteryBound = true;
    window.addEventListener('klaviyoForms', onKlaviyoForms);
    document.addEventListener('klaviyoForms', onKlaviyoForms, true);
    document.addEventListener('input', onEmailInput, true);
    document.addEventListener('change', onEmailInput, true);
    document.addEventListener('focusout', onEmailInput, true);
    document.addEventListener('click', onTadaLauncherClick, true);
    document.addEventListener('click', onLotteryPointer, true);
    document.addEventListener('pointerdown', onLotteryPointer, true);
    window.setInterval(snapshotKlaviyoEmails, 400);
    snapshotKlaviyoEmails();
    startKlaviyoSuccessWatch();
    openTadaOnPageLoad();
  }

  function getTrackedFormIds() {
    var ids = [];
    document.querySelectorAll('.bts26-blind-box-lottery[data-klaviyo-form-id]').forEach(function (el) {
      var id = String(el.getAttribute('data-klaviyo-form-id') || '').trim();
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function getSingleTrackedFormId() {
    var ids = getTrackedFormIds();
    return ids.length === 1 ? ids[0] : '';
  }

  function isTrackedForm(formId) {
    if (!formId) return false;
    return getTrackedFormIds().indexOf(String(formId)) !== -1;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function normalizeEmail(value) {
    return String(value || '').trim();
  }

  function rememberEmail(email, formId) {
    email = normalizeEmail(email);
    if (!isValidEmail(email)) return;
    lastEmail = email;
    if (formId) lastEmailsByFormId[formId] = email;
  }

  function isKlaviyoOwned(el) {
    return !!(el && el.closest && el.closest('.klaviyo-form, form.klaviyo-form, .bts26-blind-box-lottery, .common-klaviyo-form, .footer-klaviyo-form'));
  }

  function snapshotKlaviyoEmails() {
    document.querySelectorAll('.bts26-blind-box-lottery').forEach(function (section) {
      var formId = section.getAttribute('data-klaviyo-form-id');
      section.querySelectorAll('input').forEach(function (input) {
        if (!looksLikeEmailInput(input)) return;
        rememberEmail(input.value, formId);
      });
    });
  }

  function onEmailInput(event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT') return;
    var section = input.closest('.bts26-blind-box-lottery');
    if (!section) return;
    rememberEmail(input.value, section.getAttribute('data-klaviyo-form-id'));
  }

  function onLotteryPointer(event) {
    var section = event.target && event.target.closest && event.target.closest('.bts26-blind-box-lottery');
    if (!section) return;
    snapshotKlaviyoEmails();
  }

  function onTadaLauncherClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('#tadaWidget [class*="ClickableTrigger"], #tadaWidget [class*="Trigger"]')) return;

    // The floating launcher is a valid entry point on its own. Once clicked,
    // allow Tada to render its lottery popup instead of treating it as an
    // unsolicited popup before subscription.
    allowTadaPopup();
  }

  function getLotterySection() {
    return document.querySelector('.bts26-blind-box-lottery');
  }

  function extractEmailFromUnknown(value, depth) {
    if (depth > 5 || value == null) return '';
    if (typeof value === 'string') return isValidEmail(value) ? normalizeEmail(value) : '';
    if (typeof value !== 'object') return '';
    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        var fromList = extractEmailFromUnknown(value[i], depth + 1);
        if (fromList) return fromList;
      }
      return '';
    }
    var keys = Object.keys(value);
    var k;
    for (k = 0; k < keys.length; k++) {
      if (/email/i.test(keys[k]) && isValidEmail(value[keys[k]])) return normalizeEmail(value[keys[k]]);
    }
    for (k = 0; k < keys.length; k++) {
      var nested = extractEmailFromUnknown(value[keys[k]], depth + 1);
      if (nested) return nested;
    }
    return '';
  }

  function getEmailFromForm(formId) {
    snapshotKlaviyoEmails();
    var cached = (formId && lastEmailsByFormId[formId]) || lastEmail;
    if (isValidEmail(cached)) return cached;
    var section = document.querySelector('.bts26-blind-box-lottery[data-klaviyo-form-id="' + formId + '"]');
    var input = section && section.querySelector('input');
    var fromInput = input ? normalizeEmail(input.value) : '';
    return isValidEmail(fromInput) ? fromInput : '';
  }

  function onKlaviyoForms(event) {
    if (!event || !event.detail) return;
    var type = event.detail.type;
    var formId = event.detail.formId || event.detail.formID || event.detail.form_id || '';
    if (type !== 'submit' && type !== 'stepSubmit' && type !== 'formSubmitted' && type !== 'submitted' && type !== 'success') return;
    if (!formId) formId = getSingleTrackedFormId();
    if (!isTrackedForm(formId)) return;
    snapshotKlaviyoEmails();
    var email = extractEmailFromUnknown(event.detail, 0) || getEmailFromForm(formId);
    rememberEmail(email, formId);
    klaviyoSubmitTriggered = true;
    openTadaLottery(email);
  }

  function hasVisibleKlaviyoForm(root) {
    return !!(root && root.querySelector && root.querySelector('form, [data-testid="form-row"], [data-testid="form-component"], input, button, textarea, select'));
  }

  function looksLikeKlaviyoSuccess(root) {
    if (!root || !root.querySelectorAll) return false;
    var form = root.querySelector('form');
    var rows = root.querySelectorAll('[data-testid="form-row"], [data-testid="form-component"]');
    var alertNodes = root.querySelectorAll('[role="status"], [role="alert"], [data-testid="submit-announcer"], [data-testid="success"], [class*="success"], [class*="Success"]');
    if (klaviyoSubmitTriggered && !form) return true;
    if (klaviyoSubmitTriggered && form && !rows.length) return true;
    for (var i = 0; i < alertNodes.length; i++) {
      var alertText = String(alertNodes[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (alertText && /thank(s| you)|success|subscribed|you're in|you are in|done|confirmed/.test(alertText)) return true;
    }
    var text = String(root.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (text && /thank(s| you)|success|subscribed|you're in|you are in|done|confirmed/.test(text)) return true;
    return false;
  }

  function getKlaviyoSuccessEmail(root) {
    if (!root || !root.querySelectorAll) return '';
    var inputs = root.querySelectorAll('input[type="email"], input:not([type])');
    for (var i = 0; i < inputs.length; i++) {
      var value = normalizeEmail(inputs[i].value);
      if (isValidEmail(value)) return value;
    }
    return lastEmail || '';
  }

  function tryOpenFromKlaviyoSuccess() {
    var section = getLotterySection();
    if (!section) return false;
    if (!looksLikeKlaviyoSuccess(section)) return false;
    openTadaLottery(getKlaviyoSuccessEmail(section));
    return true;
  }

  function getTadaTrigger() {
    return document.querySelector('#tadaWidget [class*="ClickableTrigger"]') ||
      document.querySelector('#tadaWidget [class*="Trigger"]');
  }

  function isTadaAllowed() {
    return tadaAllowed || document.body.classList.contains('bts26-tada-allowed');
  }

  function allowTadaPopup() {
    tadaAllowed = true;
    document.documentElement.classList.add('bts26-tada-allowed');
    document.body.classList.add('bts26-tada-allowed');
    if (tadaSuppressObserver) {
      tadaSuppressObserver.disconnect();
      tadaSuppressObserver = null;
    }
    if (tadaGuardTimer) {
      window.clearInterval(tadaGuardTimer);
      tadaGuardTimer = null;
    }
    if (tadaScanTimer) {
      window.clearTimeout(tadaScanTimer);
      tadaScanTimer = null;
    }
  }

  function isTadaLauncher(el) {
    if (!el) return false;
    if (el.id === 'tadaWidget' || el.id === 'tada-flower-falling' || el.id === 'tada-flower-falling-canvas') return true;
    return !!(el.closest && el.closest('[class*="ClickableTrigger"]'));
  }

  function closestFixedRoot(el) {
    var node = el;
    var found = null;
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.id === 'tadaWidget') break;
      if (node.nodeType === 1) {
        var style = window.getComputedStyle(node);
        if (style.position === 'fixed') found = node;
      }
      node = node.parentElement;
    }
    return found;
  }

  function looksLikeTadaPopupRoot(el) {
    if (!el || isKlaviyoOwned(el) || isTadaLauncher(el)) return false;
    var text = String(el.textContent || '').toLowerCase();
    if (!text) return false;
    if (text.indexOf('choose your gift') !== -1) return true;
    if (text.indexOf('no thanks') !== -1 && /email|discount|gift/.test(text)) return true;
    if (text.indexOf('you get a discount') !== -1) return true;
    return false;
  }

  function markTadaPopup(el) {
    if (!el || isTadaLauncher(el) || el.hasAttribute('data-bts26-tada-popup')) return;
    el.setAttribute('data-bts26-tada-popup', '1');
  }

  function unlockUnallowedTadaScroll() {
    if (isTadaAllowed() || !getLotterySection()) return;

    [document.documentElement, document.body].forEach(function (el) {
      if (!el) return;
      el.classList.remove('overflow-hidden');
      if (el.style && el.style.overflow === 'hidden') el.style.overflow = '';
    });
  }

  function scanAndHideUnallowedTadaPopup() {
    if (isTadaAllowed()) return;

    var widget = document.getElementById('tadaWidget');
    if (widget) {
      widget.querySelectorAll('[class*="Popup"], [class*="Modal"], [class*="Overlay"], [class*="Dialog"], [class*="Backdrop"]').forEach(markTadaPopup);
      collectInputs(widget).forEach(function (input) {
        if (!looksLikeEmailInput(input) && !isTadaTextCandidate(input)) return;
        var root = closestFixedRoot(input);
        if (root && looksLikeTadaPopupRoot(root)) markTadaPopup(root);
      });
    }

    document.querySelectorAll('a, button, [role="button"]').forEach(function (el) {
      var label = String(el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'no thanks' && label !== 'no, thanks') return;
      markTadaPopup(closestFixedRoot(el) || el.parentElement);
    });

    unlockUnallowedTadaScroll();
  }

  function startTadaAutoOpenGuard() {
    scanAndHideUnallowedTadaPopup();
    if (isTadaAllowed()) return;
    if (!tadaGuardTimer) {
      tadaGuardTimer = window.setInterval(function () {
        if (isTadaAllowed()) {
          window.clearInterval(tadaGuardTimer);
          tadaGuardTimer = null;
          return;
        }
        scanAndHideUnallowedTadaPopup();
      }, 300);
    }
    if (tadaSuppressObserver) return;
    tadaSuppressObserver = new MutationObserver(function () {
      if (tadaScanTimer || isTadaAllowed()) return;
      tadaScanTimer = window.setTimeout(function () {
        tadaScanTimer = null;
        scanAndHideUnallowedTadaPopup();
      }, 50);
    });
    tadaSuppressObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function openTadaOnPageLoad() {
    allowTadaPopup();
    tryOpenTadaFromPageLoad();
  }

  function getTadaAutoOpenTarget() {
    var widget = document.getElementById('tadaWidget');
    if (!widget) return null;
    return widget.querySelector('[class*="ClickableTrigger"], [class*="Trigger"], button, [role="button"], a[href]') ||
      widget.firstElementChild ||
      widget;
  }

  function tryOpenTadaFromPageLoad() {
    var started = Date.now();
    var timer = window.setInterval(function () {
      if (isTadaPopupPresent()) {
        window.clearInterval(timer);
        openedAt = Date.now();
        return;
      }

      var target = getTadaAutoOpenTarget();
      if (target && isElementVisible(target)) {
        if (target.click) target.click();
        openedAt = Date.now();
        window.clearInterval(timer);
        return;
      }

      if (Date.now() - started >= AUTO_OPEN_WAIT_MS) {
        window.clearInterval(timer);
      }
    }, AUTO_OPEN_POLL_MS);
  }

  function stopKlaviyoSuccessWatch() {
    if (successObserver) {
      successObserver.disconnect();
      successObserver = null;
    }
    if (successScanTimer) {
      window.clearTimeout(successScanTimer);
      successScanTimer = null;
    }
  }

  function startKlaviyoSuccessWatch() {
    if (successObserver) return;
    if (tryOpenFromKlaviyoSuccess()) return;
    var section = getLotterySection();
    if (!section) return;
    successObserver = new MutationObserver(function () {
      if (successScanTimer) return;
      successScanTimer = window.setTimeout(function () {
        successScanTimer = null;
        if (tryOpenFromKlaviyoSuccess()) {
          stopKlaviyoSuccessWatch();
        }
      }, 120);
    });
    successObserver.observe(section, { childList: true, subtree: true, characterData: true });
  }

  function isElementVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isTadaPopupPresent() {
    var markedPopups = document.querySelectorAll('[data-bts26-tada-popup="1"]');
    for (var i = 0; i < markedPopups.length; i += 1) {
      if (isElementVisible(markedPopups[i])) return true;
    }
    var found = false;
    document.querySelectorAll('a, button, [role="button"]').forEach(function (el) {
      var label = String(el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if ((label === 'no thanks' || label === 'no, thanks') && isElementVisible(el)) found = true;
    });
    return found;
  }

  function waitFor(check, timeout, onFound, onMiss) {
    var started = Date.now();
    (function poll() {
      var result = check();
      if (result) {
        onFound(result);
        return;
      }
      if (Date.now() - started >= timeout) {
        if (onMiss) onMiss();
        return;
      }
      window.setTimeout(poll, POLL_MS);
    })();
  }

  function isSkippableInputType(el) {
    var type = String(el.type || el.getAttribute('type') || 'text').toLowerCase();
    return type === 'hidden' || type === 'checkbox' || type === 'radio' || type === 'button' || type === 'submit' || type === 'reset' || type === 'file';
  }

  function looksLikeEmailInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (isSkippableInputType(el)) return false;
    if (String(el.type || '').toLowerCase() === 'email') return true;
    var bits = [
      el.getAttribute('autocomplete'),
      el.getAttribute('name'),
      el.getAttribute('id'),
      el.getAttribute('placeholder'),
      el.getAttribute('aria-label'),
      String(el.className || '')
    ].join(' ').toLowerCase();
    return /e-?mail|mail/.test(bits);
  }

  function isTadaTextCandidate(el) {
    if (!el || el.tagName !== 'INPUT' || isSkippableInputType(el)) return false;
    var type = String(el.type || 'text').toLowerCase();
    return type === 'text' || type === 'email' || type === 'search' || type === '';
  }

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function collectInputs(root, list) {
    list = list || [];
    if (!root) return list;
    if (root.tagName === 'INPUT') list.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('input').forEach(function (el) { list.push(el); });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) collectInputs(el.shadowRoot, list);
      });
    }
    if (root.shadowRoot) collectInputs(root.shadowRoot, list);
    return list;
  }

  function scoreTadaInput(el, knownInputs) {
    var score = 0;
    if (el.closest && el.closest('#tadaWidget')) score += 120;
    if (el.closest && el.closest('[class*="Popup"], [class*="Modal"], [class*="WidgetContainer"], [class*="Game"]')) score += 60;
    if (knownInputs && !knownInputs.has(el)) score += 50;
    if (isVisible(el)) score += 30;
    if (/e-?mail/i.test(el.getAttribute('placeholder') || '')) score += 40;
    if ((el.type || '').toLowerCase() === 'email') score += 20;
    return score;
  }

  function findTadaEmailInput(knownInputs) {
    var roots = [document.getElementById('tadaWidget'), document.body];
    var best = null;
    var bestScore = 0;
    var seen = [];

    roots.forEach(function (root) {
      collectInputs(root).forEach(function (el) {
        if (seen.indexOf(el) !== -1) return;
        seen.push(el);
        if (isKlaviyoOwned(el)) return;
        if (!looksLikeEmailInput(el) && !isTadaTextCandidate(el)) return;
        if (!looksLikeEmailInput(el) && !(el.closest && el.closest('#tadaWidget')) && !(knownInputs && !knownInputs.has(el) && isVisible(el))) return;
        var score = scoreTadaInput(el, knownInputs);
        if (!looksLikeEmailInput(el)) score -= 20;
        if (score > bestScore) {
          best = el;
          bestScore = score;
        }
      });
    });

    if (best && bestScore >= 50) return best;
    return null;
  }

  function setReactInputValue(input, value) {
    var proto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    var tracker = input._valueTracker;
    if (tracker && typeof tracker.setValue === 'function') tracker.setValue('');
    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;
    try {
      input.dispatchEvent(new InputEvent('input', { bubbles: true, cancelable: true, data: value, inputType: 'insertFromPaste' }));
    } catch (err) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
  }

  function preventEmailEdit(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function lockEmailInput(input) {
    input.readOnly = true;
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('aria-readonly', 'true');
    input.classList.add('bts26-tada-email-locked');
    if (input.getAttribute('data-bts26-locked') === '1') return;
    input.setAttribute('data-bts26-locked', '1');
    input.addEventListener('keydown', preventEmailEdit, true);
    input.addEventListener('beforeinput', preventEmailEdit, true);
    input.addEventListener('paste', preventEmailEdit, true);
    input.addEventListener('cut', preventEmailEdit, true);
    input.addEventListener('drop', preventEmailEdit, true);
  }

  function applyEmailToInput(input, email) {
    try { input.focus(); } catch (err) {}
    setReactInputValue(input, email);
    if (normalizeEmail(input.value) !== email) setReactInputValue(input, email);
  }

  function fillAndLockTadaEmail(email, knownInputs) {
    if (!isValidEmail(email)) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[bts26] No subscribed email was captured before opening Tada.');
      }
      return;
    }

    waitFor(
      function () { return findTadaEmailInput(knownInputs); },
      EMAIL_WAIT_MS,
      function (input) {
        applyEmailToInput(input, email);
        window.setTimeout(function () {
          var current = findTadaEmailInput(knownInputs) || input;
          applyEmailToInput(current, email);
          lockEmailInput(current);
        }, 160);
        watchLockedEmail(email, knownInputs);
      },
      function () {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[bts26] Tada email input was not found.');
        }
      }
    );
  }

  function stopEmailLockWatch() {
    if (emailLockObserver) {
      emailLockObserver.disconnect();
      emailLockObserver = null;
    }
    if (emailLockTimer) {
      window.clearTimeout(emailLockTimer);
      emailLockTimer = null;
    }
  }

  function watchLockedEmail(email, knownInputs) {
    stopEmailLockWatch();
    emailLockObserver = new MutationObserver(function () {
      var input = findTadaEmailInput(knownInputs);
      if (!input) return;
      if (normalizeEmail(input.value) !== email) applyEmailToInput(input, email);
      lockEmailInput(input);
    });
    emailLockObserver.observe(document.body, { childList: true, subtree: true });
    emailLockTimer = window.setTimeout(stopEmailLockWatch, LOCK_WATCH_MS);
  }

  function snapshotAllInputs() {
    return new Set(collectInputs(document.body));
  }

  function openTadaLottery(email) {
    var now = Date.now();
    if (opening || now - openedAt < OPEN_LOCK_MS) return;
    opening = true;
    snapshotKlaviyoEmails();
    email = isValidEmail(email) ? email : (lastEmail || '');
    allowTadaPopup();
    var knownInputs = snapshotAllInputs();

    if (isTadaPopupPresent()) {
      openedAt = Date.now();
      opening = false;
      fillAndLockTadaEmail(isValidEmail(email) ? email : lastEmail, knownInputs);
      return;
    }

    waitFor(
      getTadaTrigger,
      TADA_WAIT_MS,
      function (trigger) {
        trigger.click();
        openedAt = Date.now();
        opening = false;
        window.setTimeout(function () {
          fillAndLockTadaEmail(isValidEmail(email) ? email : lastEmail, knownInputs);
        }, 200);
      },
      function () {
        opening = false;
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[bts26] Tada widget trigger was not found.');
        }
      }
    );
  }

  boot();
})();
